import { render } from "./WordUtmModal.vue?vue&type=template&id=c1f81bdc&scoped=true"
import script from "./WordUtmModal.vue?vue&type=script&lang=js"
export * from "./WordUtmModal.vue?vue&type=script&lang=js"

import "./WordUtmModal.vue?vue&type=style&index=0&id=c1f81bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f81bdc"]])

export default __exports__